export const SignUp = ({ signUpData, setSignUpData, isValidEmail, passwordStrengthMeter, setStep, handleSignUp }) => (
  <>
    <div className="flex-col align-items-center justify-content-center">
      <div className="font-32 bold text-black p-tb-32">Complete your information</div>
    </div>
    <div className="auth-form auth-signup">
      <div className="auth-items">
        <div className="auth-row p-b-16">
          <div className="space-between">
            {/* First Name */}
            <div className="flex-col">
              <label htmlFor="firstName">First name</label>
              <input
                type="text"
                placeholder="e.g. John"
                id="firstName"
                className={`w-210 ${!signUpData.firstName && "error"}`}
                value={signUpData.firstName}
                onChange={(e) =>
                  setSignUpData((p) => ({
                    ...p,
                    firstName: e.target.value,
                  }))
                }
              />
              <span className={`auth-input-error ${signUpData.firstName.length > 0 && "visibility-hidden"}`}>This field can't be empty-item</span>
            </div>
            {/* Last Name */}
            <div className="flex-col">
              <label htmlFor="lastName">Last name</label>
              <input
                type="text"
                placeholder="e.g. John"
                id="lastName"
                className={`w-210 ${!signUpData.lastName && "error"}`}
                value={signUpData.lastName}
                onChange={(e) =>
                  setSignUpData((p) => ({
                    ...p,
                    lastName: e.target.value,
                  }))
                }
              />
              <span className={`auth-input-error ${signUpData.lastName.length > 0 && "visibility-hidden"}`}>This field can't be empty-item</span>
            </div>
          </div>
        </div>
        {/* Phone */}
        <div className="auth-row p-b-16">
          <label htmlFor="phone">Phone number</label>
          <input
            type="number"
            placeholder="(123) 456-7890"
            id="phone"
            className={`w-100p ${!signUpData.phone && "error"}`}
            value={signUpData.phone}
            onChange={(e) => setSignUpData((p) => ({ ...p, phone: e.target.value }))}
          />
          <span className="country-phone-code"> +1 </span>
          {signUpData.phone.length === 0 && <span className="auth-input-error">This field can't be empty-item</span>}
          {signUpData.phone.length === 13 && (
            <span className="font-12 h-16 lh-16 align-items-center">We will send a verification code to this number.</span>
          )}
          {signUpData.phone && <span className={`h-16 ${signUpData.phone.length === 12 && "hide"}`} />}
        </div>

        {/* organization */}
        <div className="auth-row p-b-16">
          <label htmlFor="organization">Organization</label>
          <input
            type="text"
            placeholder="organization"
            id="organization"
            className={`w-100p ${!signUpData.organization && "error"}`}
            value={signUpData.organization}
            onChange={(e) => setSignUpData((p) => ({ ...p, organization: e.target.value }))}
          />
          <span className={`auth-input-error ${signUpData.organization.length > 0 && "visibility-hidden"}`}>This field can't be empty-item</span>
        </div>

        {/* email */}
        <div className="auth-row p-b-16">
          <label htmlFor="email">Email</label>
          <input
            type="text"
            placeholder="email"
            id="email"
            className={`w-100p ${!signUpData.email && "error"}`}
            value={signUpData.email}
            onChange={(e) => setSignUpData((p) => ({ ...p, email: e.target.value }))}
          />
          {signUpData.email.length === 0 && <span className="auth-input-error">This field can't be empty-item</span>}
          {signUpData.email.length > 0 && (
            <span className={`auth-input-error ${isValidEmail(signUpData.email) && "visibility-hidden"}`}>Format is invalid</span>
          )}
        </div>

        {/* Password */}
        <div className="auth-row p-b-16">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            placeholder="set a password"
            id="password"
            className={`w-100p ${!signUpData.password && "error"}`}
            value={signUpData.password}
            onChange={(e) => setSignUpData((p) => ({ ...p, password: e.target.value }))}
          />
          {signUpData.password.length === 0 ? (
            <span className="auth-input-error">At least 8 characters contains words, numbers & symbols.</span>
          ) : (
            <span className="font-12 h-16 lh-16 align-items-center">
              Password strength:&nbsp;<span> {passwordStrengthMeter.strength} </span>
            </span>
          )}
          <div className="progress2 progress-moved">
            <div
              className="progress-bar2"
              style={{
                width: passwordStrengthMeter.width,
                backgroundColor: passwordStrengthMeter.color,
              }}
            />
          </div>
        </div>

        <div className="auth-row">
          <div className="justify-content-center">
            <span onClick={() => setStep("forget")} className="fg-text-gray pointer">
              Forgot your password?
            </span>
            &#160;
            <span onClick={() => setStep("login")} className="dev-mode pointer">
              Sign In
            </span>
          </div>
        </div>

        <div className="auth-row p-tb-24">
          <div
            className={`btn-full 
                    ${
                      (!signUpData.firstName ||
                        !signUpData.lastName ||
                        !signUpData.phone ||
                        !signUpData.organization ||
                        !signUpData.email ||
                        !signUpData.password ||
                        // passwordStrengthMeter.strength !== "Excellent" ||
                        !isValidEmail(signUpData.email)) &&
                      "disable"
                    }`}
            onClick={handleSignUp}>
            <span className="p-lr-8">Continue</span>
          </div>
        </div>
        <div className="auth-row">
          <span className="fg-text-gray font-12 justify-content-center">
            By proceeding, you agree to the &nbsp;
            <span className="text-underline pointer">Terms and Conditions</span>
            &nbsp;and&nbsp;
            <span className="text-underline pointer">Privacy Policy</span>
            &nbsp;.
          </span>
        </div>
      </div>
    </div>
  </>
);
